import { render, staticRenderFns } from "./DxfLayersListWrapper.vue?vue&type=template&id=fb3d5da4&scoped=true&"
import script from "./DxfLayersListWrapper.vue?vue&type=script&lang=js&"
export * from "./DxfLayersListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DxfLayersListWrapper.vue?vue&type=style&index=0&id=fb3d5da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3d5da4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
